import React, { Component } from "react"
import { connect } from "react-redux"
import { requestResource } from "home/api_request"
import { EnemExamSessionsTablePresentation } from "home/components/enem_exam"
import TableWrapper from "home/components/table_wrapper"

const RESOURCE = "enem_exam/sessions"

class EnemExamSessionsTableContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      tableData: {
        data: null,
        columns: null
      }
    }
  }

  componentDidMount () {
    this.updateData()
  }

  componentDidUpdate (prevProps) {
    if (JSON.stringify(prevProps.filters) != JSON.stringify(this.props.filters)) {
      this.updateData()
    }
  }

  updateData () {
    const { filters } = this.props

    requestResource(RESOURCE, filters, response => this.setChartConfigFromResponse(response))
  }

  setChartConfigFromResponse (response) {
    this.setState({
      tableData: response.data
    })
  }

  render () {
    return (
      <TableWrapper
        presenter={EnemExamSessionsTablePresentation}
        tableData={this.state.tableData}
        resource={RESOURCE}
        filters={this.props.filters}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    filters: {
      userId: state.filters.userId,
      schoolYear: state.filters.schoolYear,
      schoolClass: state.filters.schoolClass,
      schoolId: state.filters.schoolId,
      "enemExams/sessions/examId": state.filters["enemExams/sessions/examId"]
    }
  }
}

export default connect(mapStateToProps)(EnemExamSessionsTableContainer)
